'use client';
import * as React from 'react';

import { cn } from '@/lib/utils';
import type { Job, Store } from '@/lib/types/customer/restaurant/StoreProfile';

import { JobPositionCard } from '@/components/store/jobs/JobPositionCard';

type Props = {
  store: Store;
};
const RestaurantJobList = ({ store }: Props) => {
  const [showMore] = React.useState<boolean>(true);
  const jobs = store?.jobs;
  const storeName = store?.name;

  if (!store.features.crud_on_jobs) {
    return <></>;
  }

  return (
    <div className="positions-open space-y-3">
      {jobs.map((job: Job, idx: number) => {
        return (
          <div
            key={job.id}
            className={cn(idx > 2 && 'hidden', showMore && 'visible')}
          >
            <JobPositionCard
              job={job}
              storeName={storeName}
              city={store.city}
            />
          </div>
        );
      })}
    </div>
  );
};

export default RestaurantJobList;
